module.exports = __webpack_public_path__ + "static/media/de.bd95c9ea.svg";